import React, { useState } from "react";
import "./queryList.css";
// css comes in replyQuery.css
import ReplyQuery from "../Reply Query/ReplyQuery";
import DeleteQuery from "./DeleteQuery";
import moment from "moment";
import ResolveQuery from "./ResolveQuery";
import { iconData } from "../../../../iconData";
import { IP } from "../../../../internalServer";
import DeclineQuery from "./DeclineQuery";
import MideaViewer from "../../../../midea_viewer/MideaViewer";
import DatePicker from "react-datepicker";
import axios from "../../../../axios";
import "react-datepicker/dist/react-datepicker.css";
import Popup from "reactjs-popup";
import GroupMemberList from "../Query Header/GroupMemberList";
import assets from "../../../../assets/assets";
import { Tooltip } from "@mui/material";
import { LucideTag, MessageSquareMoreIcon, Paperclip } from "lucide-react";
import { shortenParagraph } from "../../../../Utils/helper";
const QueryExpand = ({
  refetch,
  change,
  setEditQueryData,
  setQuery,
  queries,
  setDelQuery,
  setExpandQuery,
  setDataFinal,
  groupData,
  handleRefresh
}) => {
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [option, setOption] = useState("Name");
  const [clickExpandBtn, setClickExpandBtn] = useState(true);
  const [deleteQuery, setDeleteQuery] = useState();
  const [mideaviewer, setMideaviewer] = useState(false);
  const [mideaviewerAttachment, setMideaviewerAttachment] = useState();
  const [markQuery, setMarkQuery] = useState();
  const [changeStatus, setChangeStatus] = useState(false);
  const [replyfetch, setReplyFetch] = useState(false);
  const [selectedDate, setSelectedDate] = useState();
  const [isGettingReply, setIsGettingReply] = useState(false);
  const [isClearingSearch, setIsClearingSearch] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  let attachments = queries.attachments;
  const [filter, setFilter] = useState({
    date: null,
    replyText: null,
    searchClick: null,
    page: 1,
    limit: 5,
  });
  const [reply, setReply] = useState([]);
  console.log(mideaviewer, mideaviewerAttachment);
  let userId = teacher_id;
  let user;
  if (userId === queries.user_id.id) {
    user = true;
  }

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getUTCSeconds();
    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };
  const timeHelperUTC = (a) => {
    const dateObj = new Date(a);
    const updatedDateObj = new Date(
      dateObj.getTime() + 5 * 60 * 60 * 1000 + 30 * 60 * 1000
    );
    const year = updatedDateObj.getUTCFullYear();
    const month = updatedDateObj.getUTCMonth() + 1;
    const day = updatedDateObj.getUTCDate();
    const hours = updatedDateObj.getUTCHours();
    const minutes = updatedDateObj.getUTCMinutes();
    const seconds = updatedDateObj.getUTCSeconds();

    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setReply([]);
      setFilter({
        ...filter,
        searchClick: !filter.searchClick,
      });
    }
  };

  const today = new Date();
  function formatDate(inputDate) {
    console.log(inputDate);
    const dateObject = new Date(inputDate);
    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObject.getDate().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    // console.log(formattedDate);
    setSelectedDate(formattedDate);
  }
  const getReplyRefetch = async () => {
    try {
      setIsGettingReply(true);
      const response = await axios.get(
        `/api/v1/query/reply/get/${queries?.id}?sortBy=-1`
      );
      response.data.data.length > 0 && setReply(response.data.data);
    } catch (error) {
      console.log(error);
    }
    setIsGettingReply(false);
  };

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };
  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setMideaviewer(true);
  };

  return (
    <div>
      <div className="d-flex subjectWise_query_file_path">
        <img
          src="/images/BackImg.svg"
          alt=""
          className="backImg"
          onClick={() => {
            setExpandQuery(false);
            setDataFinal({});
            handleRefresh();
          }}
        />
        <div className="gap-2 p-2 d-flex align-items-center">
          <img
            src={
              groupData?.profile_picture
                ? IP + groupData?.profile_picture.replace(/^\./, "")
                : "/group-img/groupImg1.svg"
            }
            className="query_profileimg1"
            alt=""
            onError={(e) => {
              e.target.src = assets.QueryImg;
            }}
          />
          <span className="query_channelName">{groupData?.name}</span>
        </div>
      </div>
      <div
        className={`mt-3 mr-2  w-100 orange-scrollBar w-95 query_list_box_Expand ${queries?.status === "resolved"
          ? `resolveGray`
          : queries.status === "rejected"
            ? `rejectedRed`
            : ""
          }`}
        style={{
          height: "calc(100vh - 260px)",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        <div className="full_box_coleps">
          <div className=" w-100 d-flex align-items-center justify-content-between mx-3">
            <div>
              <span
                className={`mr-2 poppins-semibold  ${queries?.status === "rejected" ? "mt-0" : ""
                  } `}
              >
                {queries?.status === "pending" && (
                  <img
                    src={"/images/Pending.svg"}
                    height={60}
                    width={60}
                    alt=""
                  />
                )}
                {queries?.status === "approved" && (
                  <img
                    src={"/images/Active.svg"}
                    height={60}
                    width={60}
                    alt=""
                  />
                )}
                {queries?.status === "rejected" && (
                  <div className="">
                    <p className="rej poppins-semibold">⦿ Rejected</p>
                  </div>
                )}
                {queries?.status === "resolved" && (
                  <img
                    src={"/images/Resolved.svg"}
                    height={60}
                    width={60}
                    alt=""
                  />
                )}
              </span>

              <span className="mr-1 status_header">{queries?.book?.name}</span>
              {queries?.book?.name && queries?.chapter?.name && (
                <span className="mx-1">{`>`}</span>
              )}
              <span className="status_header">{queries?.chapter?.name}</span>
            </div>
          </div>

          <div className="gap-2 flex-wrap align-items-center justify-content-between d-flex w-100 mx-3 ">
            <div
              onClick={() =>
                !(
                  queries?.status === "pending" ||
                  queries?.status === "rejected"
                ) && (setExpandQuery(true), setDataFinal(queries))
              }
              className="comments-text poppins-semibold"
              style={{ width: "85%" }}
            >
              {queries?.query}
            </div>

            <div className="mr-4">
              {queries?.reply_count > 0 && (
                <span className="query_time d-flex gap-2">
                  {moment(timeHelperUTC(queries?.lastReplyDate)).calendar(
                    null,
                    {
                      sameDay: "[Today], h:mm A",
                      lastDay: "[Yesterday], h:mm A",
                      lastWeek: "DD MMM, h:mm A",
                      sameElse: "DD MMM YYYY, h:mm A",
                    }
                  )}
                </span>
              )}

              {queries?.reply_count === 0 && (
                <span className="query_time d-flex gap-2">
                  {moment(timeHelperUTC(queries?.created_at)).calendar(null, {
                    sameDay: "[Today], h:mm A",
                    lastDay: "[Yesterday], h:mm A",
                    lastWeek: "DD MMM, h:mm A",
                    sameElse: "DD MMM YYYY, h:mm A",
                  })}
                </span>
              )}
            </div>
          </div>

          <div className="my-1 w-100 d-flex mx-3 align-items-center justify-content-between">
            <p
              onClick={() =>
                !(
                  queries?.status === "pending" ||
                  queries?.status === "rejected"
                ) && setClickExpandBtn(!clickExpandBtn)
              }
              className="comments-text query_description mt-1 mb-0 show_query_description"
              style={{ width: "95%" }}
            >
              <div className="">{queries?.description}</div>
            </p>
          </div>

          <hr
            className="mt-1 border-3 "
            style={{
              width: "100%",
              borderBottom: "2px solid #D9D9D9",
            }}
          />

          <div className="mx-3 d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2">
              {queries?.user_id?.role === "Teacher" ? (
                <img
                  src={
                    queries?.user_id?.profile_picture
                      ? IP +
                      queries?.user_id?.profile_picture.replace(/^\./, "")
                      : queries?.user_id?.gender === "M"
                        ? "/images/Teacher_Male.jpg"
                        : queries?.user_id?.gender === "F"
                          ? "/images/Teacher_Female.png"
                          : "/images/default image.png"
                  }
                  alt="icon"
                  className=""
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                  key={queries?.user_id?.avatarProfile}
                  onError={(e) => {
                    if (queries?.user_id?.gender === "M") {
                      e.target.src = "/images/Teacher_Male.jpg";
                    } else if (queries?.user_id?.gender === "F") {
                      e.target.src = "/images/Teacher_Female.png";
                    } else {
                      e.target.src = "/images/default image.png";
                    }
                  }}
                />
              ) : (
                <img
                  src={
                    queries?.user_id?.profile_picture
                      ? IP +
                      queries?.user_id?.profile_picture.replace(/^\./, "")
                      : queries?.user_id.gender === "M"
                        ? queries?.user_id?.avatarProfile
                          ? "/images/Boys/" +
                          queries?.user_id?.avatarProfile +
                          ".webp"
                          : "/images/Student_boy_pic.png"
                        : queries?.user_id?.gender === "F"
                          ? queries?.user_id?.avatarProfile
                            ? "/images/Girls/" +
                            queries?.user_id?.avatarProfile +
                            ".webp"
                            : "/images/Student_girl_pic.png"
                          : "/images/default image.png"
                  }
                  alt="icon"
                  className=""
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                  key={queries?.user_id?.avatarProfile}
                  onError={(e) => {
                    e.target.src = queries?.user_id?.avatarProfile
                      ? "/images/Girls/" +
                      queries?.user_id?.avatarProfile +
                      ".webp"
                      : "/images/Student_girl_pic.png";
                    if (queries?.user_id?.gender === "M") {
                      e.target.src = queries?.user_id?.avatarProfile
                        ? "/images/Boys/" +
                        queries?.user_id?.avatarProfile +
                        ".webp"
                        : "/images/Student_boy_pic.png";
                    } else if (queries?.user_id?.gender === "F") {
                      e.target.src = queries?.user_id?.avatarProfile
                        ? "/images/Girls/" +
                        queries?.user_id?.avatarProfile +
                        ".webp"
                        : "/images/Student_girl_pic.png";
                    } else {
                      e.target.src = "/images/default image.png";
                    }
                  }}
                />
              )}
              {user ? (
                <span className="query_name ml-2"> you</span>
              ) : (
                <span className="query_name ml-2">
                  {" "}
                  {queries?.user_id?.name}{" "}
                </span>
              )}

              {queries?.status === "approved" && (
                <span
                  className="query_resolved"
                  name="resolved"
                  onClick={(e) => setMarkQuery(true)}
                >
                  Mark as Resolved
                </span>
              )}
            </div>
            <div className="d-flex align-items-center gap-3">
              <div className="d-flex align-items-center gap-2">
                <LucideTag size={20} style={{ transform: "rotate(90deg)" }} />
                {queries?.tags?.map((item, index) => (
                  <span key={index} className="related_query ml-1">
                    {item}
                  </span>
                ))}
              </div>
              <div className="d-flex align-items-center gap-2">
                <Paperclip size={20} />
                {attachments.length}
              </div>
              <div className="d-flex align-items-center gap-2">
                <MessageSquareMoreIcon size={20} /> {queries?.reply_count}
              </div>
            </div>
          </div>
          {/*  */}
          <div className="d-flex flex-wrap mt-2 ">
            {attachments?.length > 0 &&
              attachments?.map((attachment, index) => (
                <div
                  className="query_attach_box align-items-center py-2 px-3 mr-2 mb-2"
                  onClick={() => {
                    const fileType = attachment.split(".").pop();
                    if (
                      fileType === "jpg" ||
                      fileType === "jpeg" ||
                      fileType === "png" ||
                      fileType === "mp4" ||
                      fileType === "JPG" ||
                      fileType === "JPEG" ||
                      fileType === "PNG" ||
                      fileType === "MP4"
                    ) {
                      handleClick(attachment);
                    } else if (
                      fileType === "pdf" ||
                      fileType === "PDF" ||
                      fileType === "ppt" ||
                      fileType === "PPT" ||
                      fileType === "PPTX" ||
                      fileType === "pptx"
                    ) {
                      handleClickforpdf(attachment);
                    }
                  }}
                >
                  <>
                    {attachment.split(".").pop() === "jpg" ||
                      attachment.split(".").pop() === "jpeg" ||
                      attachment?.split(".").pop() === "JPEG" ||
                      attachment?.split(".").pop() === "JPG" ||
                      attachment?.split(".").pop() === "PNG" ||
                      attachment?.split(".").pop() === "mp4" ||
                      attachment?.split(".").pop() === "MP4" ||
                      attachment.split(".").pop() === "png" ? (
                      <div
                        // key={index}
                        onClick={() => {
                          if (!isError) {
                            handleClick(attachment);
                          }
                        }}
                        className="ContainerUploadedPdf d-flex gap-2 p-1"
                      >
                        <div className="d-flex align-items-center">
                          <img
                            style={{ maxHeight: "19px" }}
                            src={`${iconData?.find(
                              (i) =>
                                i.extension ===
                                attachment.substring(
                                  attachment.lastIndexOf(".") + 1
                                )
                            )?.icon
                              }`}
                            alt=""
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        className="d-flex align-items-center pdf_logo"
                        onClick={() => handleClickforpdf(attachment)}
                      >
                        <img
                          className="  attachLogoActivity"
                          src={`${iconData?.find(
                            (i) =>
                              i.extension ===
                              attachment?.match(/\.([^.]+)$/)[1]
                          )?.icon
                            }`}
                          alt=""
                        />
                      </div>
                    )}
                  </>
                  &nbsp;&nbsp;
                  {attachment.indexOf("_") > 0
                    ? attachment.substring(attachment.indexOf("_") + 1)
                    : attachment}
                  &nbsp;
                  <span style={{ color: "#677489" }} className=" me-2">
                    {/* (45kb) */}
                  </span>
                </div>
              ))}
          </div>
          {/* <div className="w-100">
            {clickExpandBtn && queries?.status !== "pending" && (
              <div className="d-flex justify-content-end gap-2 ">
                <button
                  className="refetch"
                  onClick={() => {
                    setReply([]);
                    getReplyRefetch();
                  }}
                >
                  Refresh
                </button>
                <div className="search_container search_reply w-100 d-flex align-items-center ">
                  <div className="d-flex align-items-center">
                    <img
                      onClick={() => {
                        setOption("Name");
                        setFilter({
                          ...filter,
                          replyText: "",
                          date: "",
                          page: 1,
                        });
                      }}
                      className="ml-2"
                      src={`/images/${
                        option !== "Name" ? "reply_name" : "orange_reply_name"
                      }.png`}
                      alt=""
                    />
                    <img
                      onClick={() => {
                        setOption("Date");
                        setFilter({
                          ...filter,
                          replyText: "",
                          date: "",
                          page: 1,
                        });
                      }}
                      className="ml-2"
                      src={`/images/${
                        option !== "Date"
                          ? "reply_calender"
                          : "orange_reply_calender"
                      }.png`}
                      alt=""
                    />
                    <span style={{ color: "#CCD6DD" }} className="ml-2">
                      |
                    </span>
                  </div>
                  <div className="reply_search_input">
                    {option === "Date" ? (
                      // <input
                      //   type="date"
                      //   name="date"
                      //   value={filter.date}
                      //   className="reply_calendar_box search_calendar_Box"
                      //   onKeyDown={(e) => handleKeyDown(e)}
                      //   onChange={(e) =>
                      //     setFilter({
                      //       ...filter,
                      //       replyText: null,
                      //       date: e.target.value,
                      //       page: 1,
                      //     })
                      //   }
                      // />
                      <DatePicker
                        selected={filter.date}
                        placeholderText="mm/dd/yyyy"
                        onChange={(e) => {
                          formatDate(e);
                          // setReply([]);
                          setFilter({
                            ...filter,
                            replyText: null,
                            date: e,
                            page: 1,
                          });
                        }}
                        className="search_calendar_Box1"
                        onKeyDown={(e) => handleKeyDown(e)}
                      />
                    ) : (
                      <input
                        type="text"
                        value={filter.replyText}
                        className="reply_search_box search_boxs"
                        placeholder="Search in query..."
                        onKeyDown={(e) => handleKeyDown(e)}
                        onChange={(e) => {
                          // setReply([]);
                          setFilter({
                            ...filter,
                            date: null,
                            page: 1,
                            replyText: e.target.value,
                          });
                        }}
                      />
                    )}
                  </div>
                  {filter.replyText || filter.date ? (
                    <img
                      src="/images/search icon black.svg"
                      className="query_search_icon"
                      style={{ opacity: 1, cursor: "pointer" }} // Icon enabled (clickable)
                      alt="Search"
                      onClick={() => {
                        setReply([]); // Clear the reply list before search
                        setFilter({
                          ...filter,
                          searchClick: !filter.searchClick, // Trigger the search by toggling searchClick
                        });
                      }}
                    />
                  ) : (
                    <img
                      src="/images/search icon black.svg"
                      className="query_search_icon"
                      style={{ opacity: 0.5, cursor: "not-allowed" }} // Icon disabled (not clickable)
                      alt="Search"
                    />
                  )}
                </div>
                <p
                  style={{
                    color: "#f88409",
                    fontWeight: "500",
                    fontSize: "14px",
                    textDecoration: "underline",
                    width: "10%",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setFilter({
                      date: null,
                      // tag: "",
                      // name: "",
                      // status: "all",
                      // sortBy: -1,
                      // time: null,
                      // limit: Infinity,
                      // page: 1,
                      searchClick: false,
                      replyText: "",
                    });
                    setReply([]);
                    setIsClearingSearch(true);
                    getReplyRefetch();
                  }}
                >
                  Clear Search
                </p>
              </div>
            )}
          </div> */}

          <div className="w-100">
            {clickExpandBtn && queries?.status !== "pending" && (
              <div className="d-flex justify-content-end w-100">
                <div className="d-flex align-items-center flex-wrap gap-2">
                  {/* refresh button */}
                  <button
                    className="refresh"
                    onClick={() => {
                      setReply([]);
                      getReplyRefetch();
                    }}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Refresh
                  </button>

                  {/* Search Section  */}
                  <div
                    className="search_container search_reply d-flex align-items-center"
                    style={{ width: "auto", maxWidth: "300px" }}
                  >
                    <div className="d-flex align-items-center">
                      <img
                        onClick={() => {
                          setOption("Name");
                          setFilter({
                            ...filter,
                            replyText: "",
                            date: "",
                            page: 1,
                          });
                        }}
                        className="ml-2"
                        src={`/images/${option !== "Name" ? "reply_name" : "orange_reply_name"
                          }.png`}
                        alt=""
                      />
                      <img
                        onClick={() => {
                          setOption("Date");
                          setFilter({
                            ...filter,
                            replyText: "",
                            date: "",
                            page: 1,
                          });
                        }}
                        className="ml-2"
                        src={`/images/${option !== "Date"
                          ? "reply_calender"
                          : "orange_reply_calender"
                          }.png`}
                        alt=""
                      />
                      <span style={{ color: "#CCD6DD" }} className="ml-2">
                        |
                      </span>
                    </div>
                    <div className="reply_search_input">
                      {option === "Date" ? (
                        // <input
                        //   type="date"
                        //   name="date"
                        //   value={filter.date}
                        //   className="reply_calendar_box search_calendar_Box"
                        //   onKeyDown={(e) => handleKeyDown(e)}
                        //   onChange={(e) =>
                        //     setFilter({
                        //       ...filter,
                        //       replyText: null,
                        //       date: e.target.value,
                        //       page: 1,
                        //     })
                        //   }
                        // />
                        <DatePicker
                          selected={filter.date}
                          placeholderText="mm/dd/yyyy"
                          onChange={(e) => {
                            formatDate(e);
                            // setReply([]);
                            setFilter({
                              ...filter,
                              replyText: null,
                              date: e,
                              page: 1,
                            });
                          }}
                          className="search_calendar_Box1"
                          onKeyDown={(e) => handleKeyDown(e)}
                        />
                      ) : (
                        <input
                          type="text"
                          value={filter.replyText}
                          className="reply_search_box search_boxs"
                          placeholder="Search in query..."
                          onKeyDown={(e) => handleKeyDown(e)}
                          onChange={(e) => {
                            // setReply([]);
                            setFilter({
                              ...filter,
                              date: null,
                              page: 1,
                              replyText: e.target.value,
                            });
                          }}
                        />
                      )}
                    </div>

                    {filter.replyText || filter.date ? (
                      <img
                        src="/images/search icon black.svg"
                        className="query_search_icon"
                        style={{ opacity: 1, cursor: "pointer" }} // Icon enabled (clickable)
                        alt="Search"
                        onClick={() => {
                          setReply([]); // Clear the reply list before search
                          setFilter({
                            ...filter,
                            searchClick: !filter.searchClick, // Trigger the search by toggling searchClick
                          });
                        }}
                      />
                    ) : (
                      <img
                        src="/images/search icon black.svg"
                        className="query_search_icon"
                        style={{ opacity: 0.5, cursor: "not-allowed" }} // Icon disabled (not clickable)
                        alt="Search"
                      />
                    )}
                  </div>

                  {/* Clear Search */}
                  <p
                    style={{
                      color: "#f88409",
                      fontWeight: "500",
                      fontSize: "14px",
                      textDecoration: "underline",
                      cursor: "pointer",
                      margin: 0,
                      whiteSpace: "nowrap",
                    }}
                    onClick={() => {
                      setFilter({
                        date: null,
                        searchClick: false,
                        replyText: "",
                      });
                      setReply([]);
                      setIsClearingSearch(true);
                      getReplyRefetch();
                    }}
                  >
                    Clear Search
                  </p>
                </div>
              </div>
            )}
          </div>

          <div className="px-3">
            <ReplyQuery
              id={reply.length}
              filter={filter}
              setFilter={setFilter}
              reply={reply}
              setReply={setReply}
              queryStatus={queries.status}
              queryId={queries.id}
              replyfetch={replyfetch}
              date1={selectedDate}
              arrowFetch={clickExpandBtn}
              groupData={groupData}
              isGettingReply={isGettingReply}
              isClearingSearch={isClearingSearch}
              getReplyRefetch={getReplyRefetch}
            />
          </div>
        </div>

        {mideaviewer && (
          <MideaViewer
            closeMideaviewer={() => setMideaviewer(!mideaviewer)}
            attachment={responseAttach}
          />
        )}
        {isClicked &&
          (responseAttach.split(".").pop() === "mp4" ||
            responseAttach.split(".").pop() === "MP4" ? (
            <div className="fullSizeImg ">
              <div className="SubfullSizeImg">
                <video className="videoPlayer" controls>
                  <source
                    src={IP + responseAttach.replace(/^\./, "")}
                    type="video/mp4"
                  />
                </video>
                <div>
                  <img
                    className="crossIconImgQue"
                    onClick={handleClick}
                    src="/images/cross.png"
                    alt="Up Arrow"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="fullSizeImg ">
              <div className="SubfullSizeImg">
                {!isError ? (
                  <>
                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true);
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div
                    className="fullSizeImg"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <img
                      onClick={() => {
                        handleClick();
                        setIsError(false);
                      }}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{
                        position: "absolute",
                        top: "75px",
                        right: "40%",
                      }}
                    />
                    <img
                      src="/images/no-photo-1.png"
                      alt="img"
                      style={{ width: "25%" }}
                    />
                    <p
                      style={{
                        color: "red",
                        fontSize: "20px",
                        fontWeight: "500",
                        marginRight: "35px",
                      }}
                    >
                      Error!! failed to load the requested file!
                    </p>
                  </div>
                )}
              </div>
            </div>
          ))}

        {deleteQuery && (
          <DeleteQuery
            reload={refetch}
            setDelQuery={setDelQuery}
            setDeleteQuery={setDeleteQuery}
            setQuery={setQuery}
            queryId={queries.id}
          />
        )}
        {markQuery && (
          <ResolveQuery
            setQuery={setQuery}
            setDelQuery={setDelQuery}
            setMarkQuery={setMarkQuery}
            setExpandQuery={setExpandQuery}
            setDataFinal={setDataFinal}
            queryId={queries.id}
          />
        )}
        {changeStatus && (
          <DeclineQuery
            queryStatus={changeStatus}
            setChangeStatus={setChangeStatus}
            setQuery={setQuery}
            queryId={queries.id}
          />
        )}
      </div>
    </div>
  );
};

export default QueryExpand;
